import { useDispatch } from 'react-redux';
import { lt, showSuccessAlert } from '@mews/framework';
import { useInvalidateRepositoryQuery, useRepositoryMutation } from '@mews-commander/data-access';
import { forceReload } from '../../app/actions/common';

export const useUpdateCurrentUserMutation = () => {
    const invalidateQuery = useInvalidateRepositoryQuery();
    const dispatch = useDispatch();

    return useRepositoryMutation('users', 'updateCurrent', {
        onSuccess: (_, params) => {
            if (['preferredLanguageCode', 'preferredCultureCode'].some((k) => k in params)) {
                dispatch(forceReload());
            } else {
                showSuccessAlert({ description: lt('ChangesSuccessfullySaved') });
                void invalidateQuery('users', 'getCurrent');
            }
        },
    });
};
